<div class="input-section font-size-14" [ngStyle]="{ 'margin-top': marginTop }">
  <label
    *ngIf="label"
    class="input-label-name font-size-14 fw-600"
    [for]="inputId"
    [ngClass]="{ 'hide-on-desktop': hideLabelOnDesktop }"
  >
    {{ label }}
    <span *ngIf="errorMessage['required']" class="text-required">*</span>
  </label>

  <div
    class="custom-dropdown"
    [ngStyle]="{ minHeight: dropdownHeight, minWidth: dropdownWidth }"
    [ngClass]="{
      'input-has-error': isInvalid,
      'with-placeholder-icon': placeholderIcon && !value,
    }"
  >
    <ng-container *ngIf="placeholderIcon && !value">
      <img alt="placeholdericon" [src]="placeholderIcon" />
    </ng-container>
    <!-- ----------------------------------------------------------------------- -->
    <!--                       For simple array of strings                       -->
    <!-- ----------------------------------------------------------------------- -->
    <ng-container *ngIf="!isArrayOfObjects()">
      <p-dropdown
        #dropdown
        styleClass="primeng-dropdown "
        className
        [placeholder]="placeholder"
        [filter]="true"
        [options]="optionList"
        [disabled]="isDropdownDisabled"
        [showClear]="showClear"
        [appendTo]="appendTo"
        [scrollHeight]="scrollHeight"
        [panelStyleClass]="panelStyleClass"
        [(ngModel)]="value"
        (onChange)="onInputChange($event)"
        (onFocus)="onDropdownFocus($event)"
      >
        <!-- ------------------ Use the passed template for items ------------------ -->
        <ng-container *ngIf="itemTemplate && selectedItemTemplate">
          <ng-template let-item pTemplate="item">
            <ng-container
              *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
            />
          </ng-template>

          <!-- -------------- Use the passed template for selected item -------------- -->
          <ng-template let-item pTemplate="selectedItem">
            <div class="selected-dropdown-item">
              <ng-container
                *ngTemplateOutlet="
                  selectedItemTemplate;
                  context: { $implicit: item }
                "
              />
            </div>
          </ng-template>
        </ng-container>

        <ng-template pTemplate="footer" *ngIf="customOptionConfig?.enabled">
          <div class="custom-option-template">
            <!-- Show button when not adding -->
            <g99-button
              variant="medium"
              iconPosition="left"
              height="40px"
              [color]="'green'"
              [svgIcon]="addIcon"
              [iconHeight]="10"
              [width]="'100%'"
              (buttonClick)="handleCustomOptionClick()"
              >{{ customOptionConfig?.addButtonText }}</g99-button
            >
          </div>
        </ng-template>
      </p-dropdown>
    </ng-container>
    <!-- ----------------------------------------------------------------------- -->
    <!--                          For array of objects                           -->
    <!-- ----------------------------------------------------------------------- -->
    <ng-container *ngIf="isArrayOfObjects()">
      <p-dropdown
        #dropdown
        styleClass="primeng-dropdown"
        [optionLabel]="getOptionLabel()"
        [optionValue]="getOptionValue()"
        [placeholder]="placeholder"
        [filter]="true"
        [showClear]="showClear"
        [filterBy]="enableSmartFilter ? '' : getOptionLabel()"
        [options]="enableSmartFilter ? filteredList : optionList"
        [disabled]="isDropdownDisabled"
        [appendTo]="appendTo"
        [scrollHeight]="scrollHeight"
        [panelStyleClass]="panelStyleClass"
        [(ngModel)]="value"
        (onChange)="onInputChange($event)"
        (onFocus)="onDropdownFocus($event)"
      >
        <!-- ------------------------- Custom filter input ------------------------- -->
        <ng-template
          *ngIf="enableSmartFilter"
          let-options="options"
          pTemplate="filter"
        >
          <div
            class="dropdown-search-wrapper"
            (click)="$event.stopPropagation()"
          >
            <div class="search-bar">
              <i class="pi pi-search search-icon"></i>
              <input
                #searchInput
                type="text"
                pInputText
                class="search-input"
                [(ngModel)]="filterValue"
                (keyup)="customFilterFunction(filterValue)"
              />
            </div>
          </div>
        </ng-template>

        <!-- ------------------ Use the passed template for items ------------------ -->
        <ng-container *ngIf="itemTemplate && selectedItemTemplate">
          <ng-template let-item pTemplate="item">
            <ng-container
              *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
            />
          </ng-template>

          <!-- -------------- Use the passed template for selected item -------------- -->
          <ng-template let-item pTemplate="selectedItem">
            <div class="selected-dropdown-item">
              <ng-container
                *ngTemplateOutlet="
                  selectedItemTemplate;
                  context: { $implicit: item }
                "
              />
            </div>
          </ng-template>
        </ng-container>
        <!-- Custom option template - always visible when enabled -->
        <ng-template pTemplate="footer" *ngIf="customOptionConfig?.enabled">
          <div class="custom-option-template">
            <!-- Show button when not adding -->
            <g99-button
              variant="medium"
              iconPosition="left"
              height="40px"
              [color]="'green'"
              [svgIcon]="addIcon"
              [iconHeight]="10"
              [width]="'100%'"
              (buttonClick)="handleCustomOptionClick()"
              >{{ customOptionConfig?.addButtonText }}</g99-button
            >
          </div>
        </ng-template>
      </p-dropdown>
    </ng-container>
  </div>

  <ng-content select=".helper-message" />
  <span *ngIf="isInvalid" class="error-msg">
    {{ getErrorMessage() }}
  </span>
  <ng-content />
</div>
